import { messages } from './messages';
import { CodeToFormattedMessageProps } from '../../errors/user-friendly-error-message-service/code-to-formatted-message-props';

const MINIMUM_LENGTH = 'MinimumLength';
const NON_CLIENT_ORDER = 'NonClientDelagatedOrder';
const SHIP_TO_NAME = 'ShipToName';
const SHIP_FROM_NAME = 'ShipFromName';

const getFriendlyIntlUnknownError = (errorMessage) => {
  switch (errorMessage) {
    case 'Stamps Terms':
      return messages.houseAccountError;
    default:
      return null;
  }
};

class LabelBatchErrorServiceClass {
  getErrorMessage(error) {
    const { errorCode = '', errorField = '', errorMessage = '' } = error || {};
    const message = messages[errorCode];
    if (message) {
      return message;
    }
    if (errorCode === MINIMUM_LENGTH && errorField === SHIP_TO_NAME) {
      return messages.minimumShipToNameLengthError;
    }
    if (errorCode === MINIMUM_LENGTH && errorField === SHIP_FROM_NAME) {
      return messages.minimumShipFromNameLengthError;
    }
    if (errorCode === NON_CLIENT_ORDER) {
      return messages.nonClientDelagatedOrder;
    }
    const friendlyMessage = getFriendlyIntlUnknownError(errorMessage);
    if (friendlyMessage) {
      return friendlyMessage;
    }

    const returnOriginalIfNoMatch = true;
    return CodeToFormattedMessageProps(errorCode, {}, errorMessage, returnOriginalIfNoMatch);
  }
}

export const LabelBatchErrorService = new LabelBatchErrorServiceClass();
